import api from "@/api/api";

const ENDPOINT = 'log';

class LogService {

    getSimulatorLogs() {
        return api().get(`/${ENDPOINT}/simulator`);
    }

    getSimulatorLogContent(logId) {
        return api().get(`/${ENDPOINT}/simulator/${logId}/content`);
    }

    getChatLogs() {
        return api().get(`/${ENDPOINT}/chat`);
    }

    downloadSimulatorLogs() {
        return this.downloadLogs('simulator');
    }

    downloadChatLogs() {
        return this.downloadLogs('chat');
    }

    downloadLogs(logType) {
        return api().get(`log/${logType}/download`, {responseType: 'blob'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'text/csv;charset=utf-8;'});
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `logs-${logType}.csv`);
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            });
    }
}

export default new LogService();